module.exports = __webpack_public_path__ + "img/clear.4f891ddb.svg";